import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getToken, setToken, clearToken, apiMe, apiLogout } from '../lib/auth';

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToken()) { setUser(null); setLoading(false); return; }
    try {
      const u = await apiMe();
      setUser(u);
    } catch (e) {
      clearToken();
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const loginSuccess = (token, u) => { setToken(token); setUser(u); };
  const logout = async () => { await apiLogout(); clearToken(); setUser(null); };

  return (
    <AdminAuthContext.Provider value={{ user, loading, refresh, loginSuccess, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
